import { lastValueFrom } from 'rxjs';
import { BaseService } from './base-service';
export class QualityWasteService {
    static getQualityWastes(filter, pageNumber) {
        let qs = encodeURIComponent(JSON.stringify(filter));
        return lastValueFrom(BaseService.getPaginated(`quality-wastes?filter=${qs}`, pageNumber));
    }
    static fetchQualityWaste(oid) {
        return lastValueFrom(BaseService.get(`quality-wastes/${oid}`));
    }
    static saveQualityWaste(dto) {
        return lastValueFrom(BaseService.save(`quality-wastes`, dto));
    }
    static deleteQualityWaste(oid) {
        return lastValueFrom(BaseService.delete(`quality-wastes/${oid}`));
    }
}
